/**
 * @generated SignedSource<<a2ab429e61d31199f54dfb55e337aade>>
 * @relayHash 73ff76db260a33de420d92d56faba723
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4edfb1456d7468560a2de440da9625895352096cce6beabbf0abda1b25e7333c

import type { ConcreteRequest } from 'relay-runtime';
export type LocalStorageInput = {
  booleanValues?: ReadonlyArray<LocalStorageBooleanPairInput | null> | null;
  stringValues?: ReadonlyArray<LocalStorageStringPairInput | null> | null;
};
export type LocalStorageBooleanPairInput = {
  key: string;
  value?: boolean | null;
};
export type LocalStorageStringPairInput = {
  key: string;
  value?: string | null;
};
export type UpdateLocalStorageMutation$variables = {
  storageinput: LocalStorageInput;
  stringKeys: ReadonlyArray<string | null>;
};
export type UpdateLocalStorageMutation$data = {
  readonly updateLocalStorage: {
    readonly stringValues: ReadonlyArray<{
      readonly key: string;
      readonly value: string | null;
    } | null>;
  } | null;
};
export type UpdateLocalStorageMutation = {
  response: UpdateLocalStorageMutation$data;
  variables: UpdateLocalStorageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storageinput"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "stringKeys"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "localStorage",
        "variableName": "storageinput"
      }
    ],
    "concreteType": "LocalStorage",
    "kind": "LinkedField",
    "name": "updateLocalStorage",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "keys",
            "variableName": "stringKeys"
          }
        ],
        "concreteType": "LocalStorageStringPair",
        "kind": "LinkedField",
        "name": "stringValues",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "key"
          },
          {
            "kind": "ScalarField",
            "name": "value"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "UpdateLocalStorageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateLocalStorageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "73ff76db260a33de420d92d56faba723",
    "id": "4edfb1456d7468560a2de440da9625895352096cce6beabbf0abda1b25e7333c",
    "metadata": {},
    "name": "UpdateLocalStorageMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateLocalStorageMutation($storageinput:LocalStorageInput!,$stringKeys:[String]!){updateLocalStorage(localStorage:$storageinput){stringValues(keys:$stringKeys){key,value}}}"
  }
};
})();

(node as any).hash = "bb8231b1a1b490a3fc8002d3b54216bf";

export default node;
